export interface SearchResult {
  title: string
  url: string
  contentType: string
  description?: string
  thumbnail?: string
}

export interface SearchResponse {
  results: SearchResult[]
  total: number
  page: number
  pageSize: number
  /**
   * Result count per category alias for the current query, independent of the
   * selected category (EGDE-660). Optional so a cached/older response shape
   * degrades to showing every category rather than none.
   */
  categoryCounts?: Record<string, number>
}

export interface RecommendedSearch {
  label: string
  term: string
}

export interface SearchCategory {
  key: string
  label: string
  contentTypeAliases: string[]
}

export interface SearchPageProps {
  locale: string
  recommended: RecommendedSearch[]
  categories: SearchCategory[]
  initialQuery?: string
  initialPage?: number
  initialCategory?: string
}

/** Results are shown 6-per-page per the design. */
export const PAGE_SIZE = 6
/** Number of autocomplete suggestions shown while typing. */
export const SUGGESTION_COUNT = 5
